module.exports = __webpack_public_path__ + "static/img/model-bg8.b2b235b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/model-bg8.jpg
// module id = uVMB
// module chunks = 0